module.exports = __webpack_public_path__ + "img/home-icon.fada1fb8.svg";